// extracted by mini-css-extract-plugin
export var content = "_8y-3";
export var list = "_8y-4";
export var settingsContent = "_8y-7";
export var settingsPanel = "_8y-8";
export var state = "_8y-6";
export var triggerBadge = "_8y-2";
export var triggerButton = "_8y-1";
export var triggerShell = "_8y-0";
export var unreadDot = "_8y-5";